import '../PublicPage.css';

export default function ItalyItineraryPage() {
    return (
        <div className="public-page italy-page">
            <header className="public-hero" style={{
                backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(/images/photo-1523906834658-6e24ef2386f9.jpg',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white'
            }}>
                <div className="public-hero-content">
                    <h1 style={{ color: 'white' }}>Italy: The Ultimate Guide</h1>
                    <p style={{ color: 'rgba(255,255,255,0.9)' }}>Eat, pray, love, and explore the most beautiful cities in the world.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>Why visit Italy?</h3>
                            <p>Italy offers an unparalleled blend of art, history, and culinary delights. From the canals of Venice to the rolling hills of Tuscany, every corner tells a story.</p>
                        </div>
                        <div className="modern-card">
                            <h3>Featured: 10 Days in Italy</h3>
                            <p>Rome, Florence, and Venice. Perfect for first-timers who want to see the "Big Three" in one trip.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>Top Destinations</h2>
                    <ul className="benefits-list">
                        <li><strong>Rome</strong>: The Eternal City, home to the Colosseum and Vatican.</li>
                        <li><strong>Florence</strong>: The Cradle of the Renaissance and Uffizi Gallery.</li>
                        <li><strong>Venice</strong>: The magical city built on water with Gondola rides.</li>
                        <li><strong>Amalfi Coast</strong>: The most dramatic and romantic coastline in Europe.</li>
                    </ul>
                </div>
            </section>

            <section className="public-section white-bg" style={{ textAlign: 'center' }}>
                <div className="section-inner">
                    <h2>Ready to plan your Italy trip?</h2>
                    <p style={{ marginBottom: '32px' }}>Let Raisa AI create a personalized itinerary for you in seconds.</p>
                    <button className="submit-btn-primary" style={{ maxWidth: '300px' }} onClick={() => window.location.href = '/?prompt=Plan a 10-day classic Italy itinerary visiting Rome, Florence and Venice'}>
                        Plan my Italy Trip
                    </button>
                </div>
            </section>
        </div>
    );
}
